import React from 'react'
import { inject, observer } from 'mobx-react'

import Ui from 'src/stores/ui'

import { HamburgerStroke } from '../UI/Icon/Icon'
import { Above, Below } from '../UI/Breakpoints'
import styles from './Hamburger.module.scss'

type Props = {
  white: boolean
  ui?: Ui
}

@inject('ui')
@observer
class Hamburger extends React.Component<Props> {
  changeMenu = (menu: string) => {
    const { ui } = this.props

    if (ui.activeMenu === menu) {
      ui!.setActiveMenu('')
    } else {
      ui!.setActiveMenu(menu)
    }
  }

  render() {
    const { white, ui } = this.props
    const hamburgerActive = ui && ui.activeMenu === 'menu'
    const isDesktop = ui && ui.windowWidth >= 1024

    return (
      <button
        aria-label="Menu button"
        onClick={() => this.changeMenu('menu')}
        className={
          hamburgerActive
            ? [styles.hamburger, styles.hamburgerActive].join(' ')
            : styles.hamburger
        }
      >
        {isDesktop ? (
          <React.Fragment>
            <HamburgerStroke
              width={26}
              height={5}
              color={white ? 'white' : '#0B0B09'}
            />
            <HamburgerStroke
              width={26}
              height={5}
              color={white ? 'white' : '#0B0B09'}
            />
            <HamburgerStroke
              width={26}
              height={5}
              color={white ? 'white' : '#0B0B09'}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <HamburgerStroke
              width={22}
              height={4}
              color={white ? 'white' : '#0B0B09'}
            />
            <HamburgerStroke
              width={22}
              height={4}
              color={white ? 'white' : '#0B0B09'}
            />
            <HamburgerStroke
              width={22}
              height={4}
              color={white ? 'white' : '#0B0B09'}
            />
          </React.Fragment>
        )}
      </button>
    )
  }
}

export default Hamburger
